import React from 'react';
import { connect } from 'react-redux';
import Table from '../../../common/table/Table';
import Const from '../Const';
import { includes } from 'lodash';
import { formatTextFloat, formatPercent } from '../../../helpers/Text';
import { REDUCER_NAME } from './../reducer';
import { compose } from 'redux';
import TooltipMajorShareHolder from './tooltip/TooltipMajorShareHolders';
import TooltipBod from './tooltip/TooltipBoD';
import { COMPONENT_RESIZE } from '../../../common/GoldenLayoutWrapper';
import TimeZoneHandle from '../../../common/timezone-handle';

class TableOwnerShip extends React.Component {
  state = {
    bottom: null,
  };

  tableRef = React.createRef();

  componentDidMount() {
    this.calcBottom();
    window.addEventListener(COMPONENT_RESIZE, this.calcBottom);
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.calcBottom);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.title && nextProps.schemaKey) {
      this.calcBottom();
    }
  }

  calcBottom = () => {
    if (!this.tableRef.current.closest('.lm_stack')) {
      return;
    }
    const bottom = this.tableRef.current
      .closest('.lm_stack')
      .getBoundingClientRect().bottom;
    this.setState({
      bottom,
    });
  };

  getDataFromRedux = () => {
    const { indexSelectTab, id } = this.props;
    if (indexSelectTab === Const.listTab.BoardOfDirectors.Index) {
      return state =>
        state[REDUCER_NAME].listMultiComponent[id].listBoardOfDirectorById;
    }
    return state =>
      state[REDUCER_NAME].listMultiComponent[id].listMajorShareHolderById;
  };

  getIds = () => {
    const {
      indexSelectTab,
      listBoardOfDirectorId,
      listMajorShareHolderId,
    } = this.props;
    if (indexSelectTab === Const.listTab.BoardOfDirectors.Index) {
      return listBoardOfDirectorId;
    }
    return listMajorShareHolderId;
  };

  getSchema = () => {
    const { bottom } = this.state;
    const { title: tabTitle, schemaKey, code, id } = this.props;

    return Object.keys(schemaKey).map(item => {
      const key = schemaKey[item];
      const title = `${tabTitle}.${item}`;
      const result = {
        key,
        title,
      };

      if (includes([Const.listTitleTableMajorShareHolders.NAME], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'left' },
          disableSort: true,
          disableResize: true,
          render: (text, item, width) => {
            if (!width) {
              return null;
            }

            return (
              <div
                className="text-left text-truncate"
                style={{ fontWeight: 'normal', width: width - 20 }} //minus 20 padding
              >
                <TooltipMajorShareHolder
                  code={item.shareHolderCode}
                  id={id}
                  bottom={bottom}
                  shareHolderName={item.shareHolderName}
                >
                  {text}
                </TooltipMajorShareHolder>
              </div>
            );
          },
        };
      }

      if (includes([Const.listTitleTableBOD.NAME], key)) {
        return {
          ...result,
          disableSort: true,
          disableResize: true,
          thStyle: { textAlign: 'left' },
          render: (text, item) => {
            return (
              <div className="text-left">
                <TooltipBod
                  code={code}
                  personId={item.personId}
                  fullName={item.fullName}
                  id={id}
                  bottom={bottom}
                >
                  <span
                    style={{
                      fontWeight: 'normal',
                      fontStyle: item.isRelationship ? 'italic' : 'normal',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {text}
                  </span>
                </TooltipBod>
              </div>
            );
          },
        };
      }

      if (
        includes(
          [
            Const.listTitleTableMajorShareHolders.PUBLIC_DATE,
            Const.listTitleTableBOD.PUBLIC_DATE,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          disableResize: true,
          thStyle: { textAlign: 'left', width: '80px' },
          render: (text, item) => {
            if (!item[key]) {
              return <div className="text-left">--</div>;
            }

            return (
              <div className="text-left">
                <TimeZoneHandle time={text} format="MM/DD/YYYY" />
              </div>
            );
          },
        };
      }

      if (includes([Const.listTitleTableBOD.POSITION], key)) {
        return {
          ...result,
          disableSort: true,
          disableResize: true,
          thStyle: { textAlign: 'left', width: '100%' },
          render: (text, item, width) => {
            if (!width) {
              return null;
            }
            const innerWidth = width - 20; //minus padding
            if (item.isRelationship) {
              return (
                <div
                  className="text-left text-truncate"
                  style={{
                    fontStyle: 'italic',
                    width: innerWidth,
                    minWidth: '150px',
                  }}
                >
                  {text}
                </div>
              );
            }
            return (
              <div
                style={{ width: innerWidth, minWidth: '150px' }}
                className="text-left text-truncate"
              >
                {text}
              </div>
            );
          },
        };
      }

      if (
        includes(
          [
            Const.listTitleTableBOD.PERCENTAGE,
            Const.listTitleTableMajorShareHolders.PERCENTAGE,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          disableResize: true,
          thStyle: { width: '80px' },
          render: (text, item) => {
            // if (text === 0) {
            //   return <span>{'--'}</span>;
            // }
            return formatTextFloat(formatPercent(text)) + '%';
          },
        };
      }

      if (
        includes(
          [
            Const.listTitleTableBOD.SHARES,
            Const.listTitleTableMajorShareHolders.SHARES,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          disableResize: true,
          thStyle: { width: '80px' },
          render: (text, item) => {
            // if (text === ZERO_VALUE) {
            //   return <span>{'--'}</span>;
            // }
            return formatTextFloat(text, 0);
          },
        };
      }

      return {
        ...result,
        render: text => text,
      };
    });
  };

  render() {
    return (
      <div ref={this.tableRef} className="d-flex flex-fill">
        <Table
          thValign="top"
          ids={this.getIds()}
          resizable={true}
          columnDraggable={false}
          rowDraggable={false}
          getDataFromRedux={this.getDataFromRedux()}
          schema={this.getSchema()}
          stickyFirstColumn={false}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    listBoardOfDirectorId:
      state[REDUCER_NAME].listMultiComponent[id].listBoardOfDirectorId,
    listMajorShareHolderId:
      state[REDUCER_NAME].listMultiComponent[id].listMajorShareHolderId,
    code: state[REDUCER_NAME].listMultiComponent[id].currentSearch.code,
    listBoardOfDirectorById:
      state[REDUCER_NAME].listMultiComponent[id].listBoardOfDirectorById,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TableOwnerShip);
